module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("Dear Reader,")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("I’m so excited to welcome you to Gold Valley, Oregon, a small Gold Rush town nestled in the mountains, surrounded by ranch land. Where the cowboys are tough and hardworking—and they just need the right women to tame them.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Smooth-Talking Cowboy")]), _vm._v(", Olivia Logan is having a rough few months.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("After a break-up she didn’t really want, she’s looking for a way to win her perfect boyfriend back—by enlisting the help of the most imperfect man she knows.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("Luke Hollister is all wrong for the Princess of Gold Valley, but the two of them together somehow feels so right. And inconvenient lust might just turn into true love.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("Happy reading!")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Maisey Yates")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08333d1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dear_Reader.vue
// module id = 75
// module chunks = 0